<template>
  <el-row :gutter="16" class="mb-16px">
    <el-col v-for="item in statCards" :key="item.label" :xs="12" :sm="8" :md="4">
      <el-card shadow="never"
        ><div class="stat-label">{{ item.label }}</div
        ><div class="stat-value">{{ item.value }}</div></el-card
      >
    </el-col>
  </el-row>

  <ContentWrap>
    <el-form :model="query" inline>
      <el-form-item label="用户昵称"
        ><BusinessLookupSelect v-model="query.userId" type="users" placeholder="请选择用户"
      /></el-form-item>
      <el-form-item label="目标用户"
        ><BusinessLookupSelect v-model="query.targetUserId" type="users" placeholder="请选择目标用户"
      /></el-form-item>
      <el-form-item label="批次号"><el-input v-model="query.batchNo" clearable /></el-form-item>
      <el-form-item label="状态">
        <el-select v-model="query.status" clearable class="!w-140px">
          <el-option
            v-for="(label, value) in statusLabels"
            :key="value"
            :label="label"
            :value="Number(value)"
          />
        </el-select>
      </el-form-item>
      <el-form-item label="推荐日期">
        <el-date-picker
          v-model="dateRange"
          type="daterange"
          value-format="YYYY-MM-DD"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
        />
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="search">查询</el-button>
      </el-form-item>
    </el-form>
  </ContentWrap>

  <ContentWrap>
    <el-table v-loading="loading" :data="list">
      <el-table-column prop="id" label="编号" width="90" />
      <el-table-column label="用户昵称" min-width="120"><template #default="scope"><BusinessLookupName type="users" :id="scope.row.userId" /></template></el-table-column>
      <el-table-column label="目标用户" min-width="120"><template #default="scope"><BusinessLookupName type="users" :id="scope.row.targetUserId" /></template></el-table-column>
      <el-table-column prop="batchNo" label="批次号" min-width="150" show-overflow-tooltip />
      <el-table-column prop="matchDate" label="推荐日期" width="120" />
      <el-table-column prop="matchScore" label="匹配分" width="90" />
      <el-table-column prop="rankNo" label="排序" width="70" />
      <el-table-column prop="reason" label="推荐理由" min-width="220" show-overflow-tooltip />
      <el-table-column prop="reasonTags" label="标签" min-width="150" show-overflow-tooltip />
      <el-table-column label="状态" width="90">
        <template #default="scope">{{ statusLabels[scope.row.status] || '未知' }}</template>
      </el-table-column>
      <el-table-column prop="exposedAt" label="曝光时间" width="180" :formatter="dateFormatter" />
      <el-table-column prop="actionAt" label="动作时间" width="180" :formatter="dateFormatter" />
    </el-table>
    <Pagination
      v-model:page="query.pageNo"
      v-model:limit="query.pageSize"
      :total="total"
      @pagination="load"
    />
  </ContentWrap>
</template>

<script setup lang="ts">
import { dateFormatter } from '@/utils/formatTime'
import * as MatchPushApi from '@/api/business/matchPush'

defineOptions({ name: 'BossCircleMatchPush' })
const loading = ref(false)
const list = ref<any[]>([])
const total = ref(0)
const stats = ref<any>({})
const dateRange = ref<string[]>([])
const statusLabels: Record<number, string> = {
  0: '待展示',
  1: '已曝光',
  2: '点击',
  3: '忽略',
  4: '采纳',
  5: '失效'
}
const query = reactive({
  pageNo: 1,
  pageSize: 10,
  userId: undefined,
  targetUserId: undefined,
  batchNo: '',
  status: undefined
})
const params = () => ({ ...query, beginDate: dateRange.value?.[0], endDate: dateRange.value?.[1] })
const statCards = computed(() => [
  { label: '推荐总数', value: stats.value.totalCount || 0 },
  { label: '曝光数', value: stats.value.exposedCount || 0 },
  { label: '点击数', value: stats.value.clickedCount || 0 },
  { label: '采纳数', value: stats.value.adoptedCount || 0 },
  { label: '点击率', value: `${stats.value.clickRate || 0}%` },
  { label: '采纳率', value: `${stats.value.adoptRate || 0}%` }
])
const load = async () => {
  loading.value = true
  try {
    const [page, summary] = await Promise.all([
      MatchPushApi.getMatchPushPage(params()),
      MatchPushApi.getMatchPushStats(params())
    ])
    list.value = page.list || []
    total.value = page.total || 0
    stats.value = summary || {}
  } finally {
    loading.value = false
  }
}
const search = () => {
  query.pageNo = 1
  load()
}
onMounted(load)
</script>

<style scoped>
.stat-label {
  color: var(--el-text-color-secondary);
}
.stat-value {
  margin-top: 8px;
  font-size: 24px;
  font-weight: 600;
}
</style>
